<script setup>
import { usePromotionStore } from "@stores/promotion";

const config = useRuntimeConfig();
const CFIMAGE_URL = config.public.CLOUDFLARE_HOST_URL;

const promotionStore = usePromotionStore();

const getImageUrl = (data) => {
  return data.image_cf 
          ? CFIMAGE_URL + data.image_cf + '/bannerModal' 
          : data.image.startsWith('http') ? data.image : `/storage${data.image}`;
}

</script>

<template>
  <section>
    <BaseCarousel
      title="Promoções"
      button-label="Ver todos"
      button-link="/promotions"
      :is-loading="promotionStore.state.isLoading"
      :is-empty="
        !promotionStore.state.isLoading &&
        promotionStore.state.promotions?.length === 0
      "
    >
      <template v-slot:default="slotProps">
        <div
          class="group relative flex aspect-video min-h-[150px] min-w-[220px] cursor-pointer flex-col rounded-md transition-all duration-200 ease-linear hover:scale-105 xs:min-w-[260px] sm:min-w-[280px] lg:min-h-[200px] lg:min-w-[340px]"
          v-if="!slotProps.isLoading"
          v-for="promotion in promotionStore.state.promotions"
          :key="promotion"
        >
          <!-- Card image -->
          <div
            :style="{
              backgroundImage: `url(${getImageUrl(promotion)})`,
            }"
            class="h-full rounded-md bg-cover bg-top bg-no-repeat bg-blend-darken"
          ></div>
          <!-- End card image -->

          <!-- Card text -->
          <div
            class="absolute top-0 flex h-full w-full flex-col items-start justify-end gap-4 rounded-md bg-promotion-header p-4 md:p-6"
          >
            <div
              class="flex w-full select-none flex-col gap-y-1 text-white md:w-3/4"
            >
              <h3
                class="text-sm font-bold !leading-tight tracking-wide lg:text-lg"
              >
                {{ promotion.name }}
              </h3>
            </div>

            <BaseButton
              variant="primary"
              class="hidden md:inline-flex"
              :to="`/promotions/${promotion.slug}`"
            >
              Participe
            </BaseButton>

            <BaseButton
              variant="primary"
              class="md:hidden"
              size="sm"
              :to="`/promotions/${promotion.slug}`"
            >
              Participe
            </BaseButton>
          </div>
          <!-- End card text -->
        </div>

        <div
          v-for="index in 12"
          :key="index"
          class="shimmer-effect relative flex aspect-video min-h-[150px] min-w-[220px] cursor-pointer flex-col rounded-md bg-red-500 transition-all duration-200 ease-linear xs:min-w-[260px] sm:min-w-[280px] lg:min-h-[200px] lg:min-w-[340px]"
          v-if="slotProps.isLoading"
        />
      </template>
    </BaseCarousel>
  </section>
</template>
